












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IPostgres95Configuration } from "sitewhere-configuration-model";

import { ContentField } from "sitewhere-ide-components";
import { VCard } from "vuetify/lib";

@Component({
  components: { VCard, ContentField }
})
export default class Postgres95Summary extends Vue {
  @Prop() readonly configuration!: IPostgres95Configuration;

  /** Hostname */
  get hostname(): string | null {
    return this.configuration ? this.configuration.hostname : null;
  }

  /** Port */
  get port(): number | null {
    return this.configuration ? this.configuration.port : null;
  }

  /** Username */
  get username(): string | null {
    return this.configuration ? this.configuration.username : null;
  }

  /** Password */
  get password(): string | null {
    return this.configuration ? this.configuration.password : null;
  }

  /** Max connections */
  get maxConnections(): number | null {
    return this.configuration ? this.configuration.maxConnections : null;
  }
}
